export const SET_SAVED_SEARCHES = 'SET_SAVED_SEARCHES';
export const DELETE_MARKETPLANNER_SAVED_SEARCH_SUCCESS = 'DELETE_MARKETPLANNER_SAVED_SEARCH_SUCCESS';
export const DELETE_MARKETPLANNER_SAVED_SEARCH_FAIL = 'DELETE_MARKETPLANNER_SAVED_SEARCH_FAIL';
export const SHOW_LOADING = 'SHOW_LOADING';